import "./WeatherScene.css";

import bgSunrise from "../../assets/weather/background/bg-sunrise.jpg";
import bgDay from "../../assets/weather/background/bg-day.jpg";
import bgSunset from "../../assets/weather/background/bg-sunset.jpg";
import bgNight from "../../assets/weather/background/bg-night.jpg";

import chisinauScene from "../../assets/weather/scene/chisinau.png";
import baltiScene from "../../assets/weather/scene/balti.png";
import cahulScene from "../../assets/weather/scene/cahul.png";
import orheiScene from "../../assets/weather/scene/orhei.png";
import comratScene from "../../assets/weather/scene/comrat.png";
import sorocaScene from "../../assets/weather/scene/soroca.png";
import ungheniScene from "../../assets/weather/scene/ungheni.png";

import rainOverlay from "../../assets/weather/overlay/rain.png";
import snowOverlay from "../../assets/weather/overlay/snow.png";
import fogOverlay from "../../assets/weather/overlay/fog.png";
import windOverlay from "../../assets/weather/overlay/wind.png";
import lightningOverlay from "../../assets/weather/overlay/lightning.png";

const BACKGROUND_MAP = {
  sunrise: bgSunrise,
  day: bgDay,
  sunset: bgSunset,
  night: bgNight,
};

const SCENE_MAP = {
  chisinau: chisinauScene,
  balti: baltiScene,
  cahul: cahulScene,
  orhei: orheiScene,
  comrat: comratScene,
  soroca: sorocaScene,
  ungheni: ungheniScene,
};

const OVERLAY_MAP = {
  rain: rainOverlay,
  snow: snowOverlay,
  sleet: snowOverlay,
  fog: fogOverlay,
  wind: windOverlay,
  thunderstorm: lightningOverlay,
};

const normalizeCity = (city) => {
  const value = String(city || "").toLowerCase().trim();

  const cityMap = {
    chisinau: "chisinau",
    "chișinău": "chisinau",
    "chişinău": "chisinau",
    balti: "balti",
    "bălți": "balti",
    "bălţi": "balti",
    cahul: "cahul",
    orhei: "orhei",
    comrat: "comrat",
    soroca: "soroca",
    ungheni: "ungheni",
  };

  return cityMap[value] || "chisinau";
};

const normalizeTimeOfDay = (timeOfDay) => {
  const value = String(timeOfDay || "").toLowerCase().trim();
  return ["sunrise", "day", "sunset", "night"].includes(value) ? value : "day";
};

const normalizeWeather = (weather) => {
  const value = String(weather || "").toLowerCase().trim();

  const weatherMap = {
    clear: "clear",
    sunny: "clear",
    "partly-cloudy": "partly-cloudy",
    partly_cloudy: "partly-cloudy",
    cloudy: "cloudy",
    overcast: "cloudy",
    rain: "rain",
    drizzle: "rain",
    thunderstorm: "thunderstorm",
    storm: "thunderstorm",
    wind: "wind",
    windy: "wind",
    snow: "snow",
    sleet: "sleet",
    fog: "fog",
    mist: "fog",
  };

  return weatherMap[value] || "clear";
};

const getOverlayClassName = (weather) => {
  const safeWeather = normalizeWeather(weather);
  const animatedTypes = ["rain", "snow", "sleet", "fog", "wind", "thunderstorm"];

  if (!animatedTypes.includes(safeWeather)) {
    return "weather-scene__overlay";
  }

  return `weather-scene__overlay weather-scene__overlay--${safeWeather}`;
};

export default function WeatherScene({
  city = "chisinau",
  weather = "clear",
  timeOfDay = "day",
}) {
  const safeCity = normalizeCity(city);
  const safeWeather = normalizeWeather(weather);
  const safeTime = normalizeTimeOfDay(timeOfDay);

  const backgroundImage = BACKGROUND_MAP[safeTime] || bgDay;
  const sceneImage = SCENE_MAP[safeCity] || chisinauScene;
  const overlayImage = OVERLAY_MAP[safeWeather] || null;
  const overlayClassName = getOverlayClassName(weather);

  return (
    <div className="weather-scene" aria-hidden="true">
      <div
        className="weather-scene__background"
        style={{ backgroundImage: `url(${backgroundImage})` }}
      />

      <div className="weather-scene__gradient" />

      <img
        className="weather-scene__scene"
        src={sceneImage}
        alt=""
        draggable="false"
      />

      {overlayImage && (
        <img
          className={overlayClassName}
          src={overlayImage}
          alt=""
          draggable="false"
        />
      )}
    </div>
  );
}